module.exports = __webpack_public_path__ + "static/media/feed-dog.247aad15.jpg";